module.exports = __webpack_public_path__ + "img/recruit4.b8d5c4a9.png";